/*
 * Copyright 2025 Intuition Robotics ltd
 */
import * as React from "react";
import {COLORS} from "@res/colors";

type Props = {
    on: boolean
    onChange: (on: boolean) => void
    children?: React.ReactNode
}

export class Checkbox
    extends React.Component<Props> {

    render() {
        const isOn = this.props.on;
        return <div className={'flex_center'}
                    onClick={() => this.props.onChange(!isOn)}
                    style={{
                        width: 13,
                        height: 13,
                        borderWidth: 1,
                        borderColor: COLORS.grays_2,
                        borderStyle: 'solid',
                        borderRadius: 2
                    }}>
            {isOn && <div className={'flex_center'}
                          style={{
                              width: 9,
                              height: 9,
                              backgroundColor: COLORS.primary_blue, // COLORS.systemGreen,
                              borderRadius: 2
                          }}>
            </div>}
        </div>;
    }

}
